import { Card } from "semantic-ui-react";

import Detail from "../../../../ui/components/Detail/Detail";

import useArticleVersionsChannelFields from "../hooks/useArticleVersionsChannelFields";

export default function ArticleVersionsModalChannelSection({
	name,
	showSubChannels,
	hasSubChannels,
	before,
	after,
	showOnlyUpdatedFields,
}) {
	const fields = useArticleVersionsChannelFields({ showSubChannels, hasSubChannels, before, after });

	if (showOnlyUpdatedFields && !fields.some((field) => field.highlighted)) {
		return null;
	}

	return (
		<Card padded fluid style={{ margin: "10px 0 10px 0" }}>
			<Card.Content>
				<div style={{ display: "grid", gridTemplateColumns: `15% repeat(${fields.length}, 1fr)`, gap: 20 }}>
					<div style={{ fontSize: 14, fontWeight: 500 }}>{name}</div>

					{fields.map(({ key, label, value, highlighted, removed }) => (
						<Detail
							key={key}
							label={label}
							value={value || "N/A"}
							highlighted={highlighted}
							removed={removed}
							style={showOnlyUpdatedFields && !highlighted ? { visibility: "hidden" } : undefined}
						/>
					))}
				</div>
			</Card.Content>
		</Card>
	);
}
